<template>
  <section class="delivery-benefit-banner" :class="{ 'delivery-benefit-banner--compact': compact }">
    <img
      class="delivery-benefit-banner__truck"
      src="@/assets/img/product/delivery-truck.png"
      alt=""
    >

    <div class="delivery-benefit-banner__group">
      <img src="@/assets/img/product/location-benefit.svg" alt="">
      <span>{{ $t('productCommon.freeShippingJabodetabek') }}</span>
    </div>

    <span class="delivery-benefit-banner__divider" aria-hidden="true"></span>

    <div class="delivery-benefit-banner__group">
      <img src="@/assets/img/product/online-process.svg" alt="">
      <span>{{ $t('productCommon.deliveryOnlineProcess') }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DeliveryBenefitBanner',
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less" scoped>
.delivery-benefit-banner {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  height: 116px;
  padding: 12px 16px;
  overflow: hidden;
  background: #EAF3FF;
  border-radius: 20px;
  color: #070D3F;

  &--compact &__truck {
    width: 96px;
  }

  &__truck {
    display: block;
    flex: 0 0 auto;
    width: 112px;
    height: 68px;
    object-fit: contain;
  }

  &__group {
    display: flex;
    flex: 1 1 0;
    align-items: center;
    min-width: 0;

    img {
      display: block;
      flex: 0 0 auto;
      width: 44px;
      height: 44px;
      margin-right: 8px;
    }

    span {
      display: -webkit-box;
      overflow: hidden;
      font-size: 26px;
      font-weight: 500;
      line-height: 34px;
      word-break: normal;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }

  &__divider {
    flex: 0 0 auto;
    width: 1px;
    height: 64px;
    margin: 0 16px;
    background: #D8E2F2;
  }
}

@media (max-width: 340px) {
  .delivery-benefit-banner {
    padding-right: 12px;
    padding-left: 12px;

    &__truck {
      width: 94px;
    }

    &__group {
      img {
        width: 40px;
        height: 40px;
        margin-right: 5px;
      }

      span {
        font-size: 24px;
        line-height: 31px;
      }
    }

    &__divider {
      margin: 0 8px;
    }
  }
}
</style>
